export {};

window.parametrize = function (varName) {
  const varFromWindow = ((window)[varName] || '').trim();
  const isVarFromWindowEmpty =
    varFromWindow.includes('${') || varFromWindow === '';
  return isVarFromWindowEmpty ? process.env[varName] : varFromWindow;
};
